// extracted by mini-css-extract-plugin
export default {"wrapper":"SlfkbbzBFxUcQFzTWBez","formWrapper":"N3GfxGv7wv8_6yx8WjRr","resourceObjectSample":"sPWUvZr8q1at2fZZUXfs"};